module.exports = "\n.panel-margin {\n    margin-left: 20px !important;\n    margin-right: 20pc !important;\n}\n\n.no-link {\n    text-decoration: none;\n    color: #444;\n}\n\n.topo-modal {\n    margin-top: 20px;\n    min-height: 280px;\n}\n\n.col-valor {\n    width: 100px;\n    text-align: center;\n    word-wrap: break-word\n}\n\n.table {\n    margin-bottom: 0px;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/detalhe-evento-operacao/detalhe-evento-operacao.component.css
// module id = ./src/app/detalhe-evento-operacao/detalhe-evento-operacao.component.css
// module chunks = main